import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { observer } from "mobx-react";
import * as React from "react";
import { useMemo } from "react";
import { getAltTagProductPage } from "@faire/retailer/features/Marketplace/utils";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { OpenSizingVariantTable } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/OpenSizingVariantTable";
import { SingleVariationSelector } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/SingleVariationSelector";
import { useVariantOptionSelectionViewState } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/useVariantOptionSelectionViewState";
var OptionSelectionBase = function(param) {
    var productAddToCartState = param.productAddToCartState, product = param.product, brand = param.brand, selectedProductOptionToken = param.selectedProductOptionToken;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var variantOptionSelectionViewState = useVariantOptionSelectionViewState(product, productAddToCartState, selectedProductOptionToken);
    var variationTypes = variantOptionSelectionViewState.variationTypes, styleVariationTypes = variantOptionSelectionViewState.styleVariationTypes;
    var isOpenSizingVariant = productAddToCartState.isOpenSizingVariant, perStyleOptionVariations = productAddToCartState.perStyleOptionVariations, perStyleTotalQuantity = productAddToCartState.perStyleTotalQuantity, minimumOrderQuantity = productAddToCartState.minimumOrderQuantity, updateSelectedQuantityByToken = productAddToCartState.updateSelectedQuantityByToken;
    var isEnglish = useMemo(function() {
        var _getLocaleKey;
        return ((_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) === Language.ENG;
    }, []);
    var singleVariationSelectorAlt = useMemo(function() {
        return getAltTagProductPage(product, isEnglish, brand.name, strictLocalize);
    }, [
        brand.name,
        isEnglish,
        product,
        strictLocalize
    ]);
    if (isOpenSizingVariant) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                styleVariationTypes.map(function(variation) {
                    return /*#__PURE__*/ _jsx(SingleVariationSelector, {
                        variationType: variation.type,
                        variationName: variation.value,
                        variationDisplayType: variation.display,
                        variantOptionSelectionViewState: variantOptionSelectionViewState,
                        alt: singleVariationSelectorAlt,
                        brand: brand
                    }, variation.value);
                }),
                /*#__PURE__*/ _jsx(OpenSizingVariantTable, {
                    brand: brand,
                    product: product,
                    perStyleOptionVariation: perStyleOptionVariations,
                    updateSelectedQuantityByToken: updateSelectedQuantityByToken,
                    minimumOrderQuantity: minimumOrderQuantity,
                    perStyleTotalQuantity: perStyleTotalQuantity
                })
            ]
        });
    }
    return variationTypes.map(function(variation) {
        return /*#__PURE__*/ _jsx(SingleVariationSelector, {
            variationType: variation.type,
            variationName: variation.value,
            variationDisplayType: variation.display,
            variantOptionSelectionViewState: variantOptionSelectionViewState,
            brand: brand
        }, variation.value);
    });
};
export var OptionSelection = observer(OptionSelectionBase);
